export class ImportContainer {
  constructor(
    public id?: string,
    public name?: string,
    public dataSourceId?: string,
    public logoLink?: string,
    public lastChanged?: Date,
    public productCount?: number,
    public catalogIds?: string[],
    public note?: string,
    public activeCatalogId?: string,
    public compareCatalogId?: string
  ) {
  }
}
